// Arrow styling in root-level css file.

export default {
  rightArrowContainer: {
    borderRadius: 4,
    position: "absolute",
    width: 40,
    right: 0,
    marginRight: -5,
  },
  leftArrowContainer: {
    borderRadius: 4,

    position: "absolute",
    left: 0,
    marginLeft: -20,
    width: 40,
  },
  leftArrowMobileContainer: {
    borderRadius: 4,
    position: "absolute",
    left: 0,
    marginLeft: 0,
    width: 40,
    zIndex: 4,
  },
  rightArrowMobileContainer: {
    borderRadius: 4,
    position: "absolute",
    right: 15,
    width: 40,
    zIndex: 4,
  },
  leftStrikeArrowContainer: {
    borderRadius: 4,
    marginRight: -22.5,
    width: 40,
  },
  leftStrikeArrowMobileContainer: {
    borderRadius: 4,
    marginRight: -30,
    width: 40,
  },
  rightStrikeArrowContainer: {
    borderRadius: 4,
    marginRight: 5,
    width: 40,
  },
  leftAdvancedStrikeArrowContainer: {
    borderRadius: 4,
    width: 40,
  },
  rightAdvancedStrikeArrowContainer: {
    borderRadius: 4,
    width: 40,
    marginLeft: "7.8%",
  },
  rightAdvancedStrikeArrowMobileContainer: {
    borderRadius: 4,
    width: 40,
    marginLeft: "1.5%",
  },
  hiddenArrow: {
    height: 0,
  },
  warningIcon: {
    height: 15,
  },
};



// WEBPACK FOOTER //
// ./src/components/Styles.js